// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface QuestionMarkFilledIconSignature {
  Element: SVGSVGElement;
}

export const QuestionMarkFilledIcon: TOC<QuestionMarkFilledIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C6.486 22 2 17.515 2 12C2 6.487 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.515 17.514 22 12 22ZM11 15V12H12C13.104 12 14 11.103 14 10C14 8.896 13.104 8 12 8C10.896 8 10 8.896 10 10H8C8 7.795 9.795 6 12 6C14.205 6 16 7.795 16 10C16 11.86 14.723 13.428 13 13.875V15H11ZM12 18.25C12.6904 18.25 13.25 17.6904 13.25 17C13.25 16.3096 12.6904 15.75 12 15.75C11.3096 15.75 10.75 16.3096 10.75 17C10.75 17.6904 11.3096 18.25 12 18.25Z"/>
</svg>
</template>;